import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Flex from '/imports/core/ui/atoms/Flex';

import { FreeAccountIcon } from '/imports/dashboard/ui/assets';
import { replaceString } from '/imports/core/ui/helpers';
import useIntl from '/imports/core/api/useIntl';
import { isBlogDomain, getRoute } from 'lib/helpers';
import { useResponsive } from 'imports/core/api/responsiveContext';

const CancelSubscriptionRequest = ({ email }) => {
  const { t, locale } = useIntl();
  const { host } = useResponsive();

  const confirmMessage = replaceString(t('contact.confirmation_link'), { EMAIL_ADDRESS: email });

  const CancelsubscriptionPolicy = replaceString(t('contact.receive_link'), {
    '/contact-us': getRoute('/contact-us', locale, false, host, isBlogDomain(host)),
  });

  return (
    <MainWrapper $fullWidth $alignItems="center" justifyContent="center">
      <InformationSection direction="column" $alignItems="center">
        <FreeAccountIcon width="80px" />
        <Title>{t('contact.check_your_inbox')}</Title>
        <Info>
          {confirmMessage}
          <span>{t('contact.click_link')}</span>
        </Info>
        <Message>
          <span dangerouslySetInnerHTML={{ __html: CancelsubscriptionPolicy }} />
        </Message>
      </InformationSection>
    </MainWrapper>
  );
};

CancelSubscriptionRequest.propTypes = {
  email: PropTypes.string,
};

const InformationSection = styled(Flex)`
  gap: 10px;
`;

const MainWrapper = styled(Flex)`
  min-height: calc(100vh - 181px);
  padding: 30px;
  background-color: #f1f0f2;

  @media (max-width: 980px) {
    margin-top: 75px;
  }

  @media (max-width: 550px) {
    padding: 30px 15px;
  }
`;

const Title = styled.div`
  font-family: ${({ theme }) => theme.font.family.websiteMedium};
  font-size: 42px;
  font-weight: bold;
  text-align: center;
  color: #282b32;
  text-align: center;

  @media (max-width: 525px) {
    font-size: 33px;
  }
`;

const Info = styled.div`
  font-family: ${({ theme }) => theme.font.family.websiteMedium};
  font-size: 25px;
  line-height: 1.53;
  color: #282b32;
  display: flex;
  flex-direction: column;
  text-align: center;
  gap: 10px;

  span {
    font-size: 17px;
  }

  @media (max-width: 525px) {
    font-size: 22px;
  }
`;

const Message = styled.div`
  font-family: ${({ theme }) => theme.font.family.websiteMedium};
  font-size: 17px;
  line-height: 1.33;
  color: #7e8592;
  text-align: center;

  a {
    color: #1688fe;
    text-decoration: none;
  }

  @media (max-width: 525px) {
    font-size: 15px;
  }
`;
export default CancelSubscriptionRequest;
